import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { tournamentsRouteI18n } from '../i18n/tournaments-route-i18n';

export function tournamentsRoutePath(config?: TranslationConfig): string {
  return `${langRoutePath(config)}/${tournamentsRouteI18n(config)}`;
}
